import api from './client';

const withWebPlatform = (data = {}) => {
  const md = data.event_metadata && typeof data.event_metadata === 'object' && !Array.isArray(data.event_metadata)
    ? data.event_metadata
    : {};

  return {
    ...data,
    event_metadata: { ...md, platform: 'web' },
  };
};

export const getJobs = (params) => api.get('/jobs', { params }).then(r => r.data);
export const getJobsStats = (params) => api.get('/jobs/stats', { params }).then(r => r.data);
export const getJob = (id) => api.get(`/jobs/${id}`).then(r => r.data);
export const createJob = (data) => api.post('/jobs', data).then(r => r.data);
export const updateJob = (id, data) => api.put(`/jobs/${id}`, data).then(r => r.data);
export const updateJobStatus = (id, data) => api.patch(`/jobs/${id}/status`, withWebPlatform(data)).then(r => r.data);
export const deleteJob = (id) => api.delete(`/jobs/${id}`).then(r => r.data);
export const restoreJob = (id, data) => api.post(`/jobs/${id}/restore`, data).then(r => r.data);
export const pauseJob = (id, data) => api.post(`/jobs/${id}/pause`, withWebPlatform(data)).then(r => r.data);
export const resumeJob = (id, data) => api.post(`/jobs/${id}/resume`, withWebPlatform(data)).then(r => r.data);
export const getActiveRoutes = () => api.get('/jobs/active-routes').then(r => r.data);
export const uploadPhotos = (jobId, formData) =>
  api.post(`/photos/${jobId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
